import { keyframes } from "@mui/system";
import io from "socket.io-client";
import { BACKEND_DOMAIN } from "../../common/env";

const token = localStorage.getItem("token");

// // Initialize Socket.IO client (update URL as per your backend)
// export const SOCKET = io("https://sc-backend.store/",{
//   auth: {
//     auth: token ? { token } : {}, // Only send token if it exists
//   },
// } 
// );

// // Initialize Socket.IO client (update URL as per your backend)
export const SOCKET = io(BACKEND_DOMAIN,{
  auth: {
    auth: token ? { token } : {}, // Only send token if it exists
  },
} 
);

// export const SOCKET = io("http://localhost:5004",{
//   auth: {
//     auth: token ? { token } : {}, // Only send token if it exists
//   },
// } 
// );

// Flip animation for the image
export const FLIP_ANIMATION = keyframes`
  0% {
    transform: rotateY(0deg);
  }
  50% {
    transform: rotateY(180deg);
  }
  100% {
    transform: rotateY(360deg);
  }
`;


// New Keyframes for 3D Animation
export const MERGE_FLY = keyframes`
  0% {
    transform: translateX(-200px) translateY(-200px) scale(0.5) rotateY(0deg);
    opacity: 0;
  }
  50% {
    transform: translateX(-50px) translateY(-50px) scale(1.2) rotateY(180deg);
    opacity: 1;
  }
  100% {
    transform: translateX(0px) translateY(0px) scale(1) rotateY(360deg);
    opacity: 1;
  }
`;

export const FADE_IN = keyframes`
  0% { opacity: 0; transform: scale(0.8); }
  100% { opacity: 1; transform: scale(1); }
`;

export const ZOOM_IN_CELEBRATION = keyframes`
  0% { opacity: 0; transform: scale(0.5); }
  50% { opacity: 1; transform: scale(1.2); }
  100% { opacity: 1; transform: scale(1); }
`;

export const FIREWORKS = keyframes`
  0% { transform: scale(0.5) translateY(0); opacity: 1; }
  50% { transform: scale(1.5) translateY(-100px); opacity: 0.8; }
  100% { transform: scale(0.1) translateY(0); opacity: 0; }
`;

export const SPARKLE = keyframes`
  0% { opacity: 1; transform: scale(1); }
  50% { opacity: 0.8; transform: scale(1.5); }
  100% { opacity: 0; transform: scale(0.5); }
`;